<template>
  <v-select
    v-model="model"
    :items="sendTypes"
    :rules="rules"
    label="Gönderim Zamanı"
    item-value="k"
    item-text="v"
    @change="$emit('type:update', status)"
  ></v-select>
</template>

<script>
import { sendTypes } from '../../../misc';

export default {
  name: 'TimeType',
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    sendTypes,
    model: 'now',
  }),
  computed: {
    status() {
      return this.model !== 'now';
    },
  },
};
</script>
